import { render, staticRenderFns } from "./ExternalLayout.vue?vue&type=template&id=3f47d2c5&scoped=true"
import script from "./ExternalLayout.vue?vue&type=script&lang=ts"
export * from "./ExternalLayout.vue?vue&type=script&lang=ts"
import style0 from "./ExternalLayout.vue?vue&type=style&index=0&id=3f47d2c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f47d2c5",
  null
  
)

export default component.exports